module.exports = __webpack_public_path__ + "img/icon_1@2x.38a8a821.png";